class alias {
  /** Коды ЧЗ/True API, отличающиеся от abb_name в справочнике ЛК */
  productGroupAbbSynonyms = {
    meddevices: "wheelchairs",
    medicine: "pharma",
    photo: "electronics",
    conserves: "conserve",
    clothes: "lp",
    dairy: "milk",
  };

  aliasCollection = [
    {
      id: 1,
      abb_name: "lp",
      name: "Предметы одежды, белье постельное, столовое, туалетное икухонное",
    },
    { id: 2, abb_name: "shoes", name: "Обувные товары" },
    { id: 3, abb_name: "tobacco", name: "Табачная продукция" },
    { id: 4, abb_name: "perfumery", name: "Духи и туалетная вода" },
    {
      id: 5,
      abb_name: "tires",
      name: "Шины и покрышки пневматические резиновые новые",
    },
    {
      id: 6,
      abb_name: "electronics",
      name: "Фотокамеры (кроме кинокамер), фотовспышки и лампы-вспышки",
    },
    {
      id: 7,
      abb_name: "pharma",
      name: "Лекарственные препараты для медицинского применения",
    },
    { id: 8, abb_name: "milk", name: "Молочная продукция" },
    { id: 9, abb_name: "bicycle", name: "Велосипеды и велосипедные рамы" },
    { id: 10, abb_name: "wheelchairs", name: "Медицинские изделия" },
    { id: 12, abb_name: "otp", name: "Альтернативная табачная продукция" },
    { id: 13, abb_name: "water", name: "Питьевая вода" },
    { id: 14, abb_name: "furs", name: "Товары из натурального меха" },
    {
      id: 15,
      abb_name: "beer",
      name: "Пиво, напитки, изготавливаемые на основе пива и слабоалкогольные напитки",
    },
    { id: 16, abb_name: "ncp", name: "Никотиносодержащая продукция" },
    { id: 17, abb_name: "bio", name: "Биологически активные добавки к пище" },
    {
      id: 19,
      abb_name: "antiseptic",
      name: "Антисептики и дезинфицирующие средства",
    },
    { id: 20, abb_name: "petfood", name: "Корма для животных" },
    { id: 21, abb_name: "seafood", name: "Морепродукты" },
    { id: 22, abb_name: "nabeer", name: "Безалкогольное пиво" },
    {
      id: 23,
      abb_name: "softdrinks",
      name: "Соковая продукция и безалкогольные напитки",
    },
    { id: 25, abb_name: "meat", name: "Мясо" },
    { id: 26, abb_name: "vetpharma", name: "Ветеринарные препараты" },
    { id: 27, abb_name: "toys", name: "Игры и игрушки для детей" },
    { id: 28, abb_name: "radio", name: "Радиоэлектронная продукция" },
    { id: 31, abb_name: "titan", name: "Титановая металлопродукция" },
    { id: 32, abb_name: "conserve", name: "Консервированная продукция" },
    { id: 33, abb_name: "vegetableoil", name: "Растительные масла" },
    {
      id: 34,
      abb_name: "opticfiber",
      name: "Оптоволокно и оптоволоконная продукция",
    },
    {
      id: 35,
      abb_name: "chemistry",
      name: "Парфюмерные и косметические средства и бытовая химия",
    },
    { id: 36, abb_name: "books", name: "Печатная продукция" },
    { id: 37, abb_name: "grocery", name: "Бакалейная продукция" },
    { id: 39, abb_name: "construction", name: "Строительные материалы" },
    {
      id: 40,
      abb_name: "fire",
      name: "Пиротехнические изделия и средства обеспечения пожарной безопасности и пожаротушения",
    },
    { id: 41, abb_name: "heater", name: "Отопительные приборы" },
    { id: 42, abb_name: "cableraw", name: "Кабельно-проводниковая продукция" },
    { id: 43, abb_name: "autofluids", name: "Моторные масла" },
    { id: 44, abb_name: "polymer", name: "Полимерные трубы" },
  ];

  normalizeProductGroupCode(raw) {
    if (raw == null) return null;
    if (typeof raw === "string") return raw.trim();
    if (typeof raw === "object") {
      const code =
        raw.abb_name ??
        raw.productGroup ??
        raw.product_group ??
        raw.code ??
        raw.pg ??
        raw.name;
      return code != null ? String(code).trim() : null;
    }
    return String(raw).trim();
  }

  resolveMarkingProductGroup(raw) {
    const code = this.normalizeProductGroupCode(raw);
    if (!code) return null;
    const lower = code.toLowerCase();
    const abbLookup = this.productGroupAbbSynonyms[lower] ?? lower;
    const byAbb = this.aliasCollection.find(
      (a) =>
        a.abb_name === abbLookup ||
        a.abb_name === lower ||
        a.abb_name === code,
    );
    if (byAbb) return byAbb;
    const byName = this.aliasCollection.find(
      (a) => a.name.toLowerCase() === lower,
    );
    if (byName) return byName;
    return {
      id: `pg-${lower}`,
      abb_name: lower,
      name: code,
    };
  }
}

export default new alias();
